<template>
  <b-list-group-item
      :variant="item.Disabled ? 'danger' : item.Blocked ? 'warning' : null"
      :href="`#/supplier/${item.id}`"
  >
    <h4 class="mb-1">
      {{ item.CompanyName }}
      <b-badge
          class="float-right"
          :variant="
          item.Disabled
            ? 'danger'
            : item.Blocked || item.OpenedAdmCases
            ? 'warning'
            : null
        "
      >
        <b-icon
            title="Disabilitato"
            class="mr-1"
            icon="bookmark-x-fill"
            v-if="item.Disabled"
        />
        <b-icon
            title="Bloccato"
            class="mr-1"
            icon="lock-fill"
            v-if="item.Blocked"
        />
        <b-icon
            title="In contenzioso"
            class="mr-1"
            icon="shield-lock"
            v-if="item.OpenedAdmCases"
        />
        {{ item.CustSupp }}
      </b-badge>
    </h4>
    <p class="mb-1">
      Indirizzo:
      <strong
      >{{ item.Address }}, {{ item.ZIPCode }} {{ item.City }} ({{
          item.County
        }}), {{ item.Country }}</strong
      >
    </p>

    <p class="mt-1 d-none d-lg-inline">
      <span
          class="p-1 my-3 mr-3 text-muted border text-nowrap"
          v-if="item.TaxIdNumber"
      >Partita IVA: <strong>{{ item.TaxIdNumber }}</strong></span
      >
      <span
          class="p-1 my-3 mr-3 text-muted border text-nowrap"
          v-if="item.FiscalCode"
      >Codice fiscale: <strong>{{ item.FiscalCode }}</strong></span
      >
      <span class="small float-right text-nowrap"
      >Ultima modifica: {{ item.TBModified }}</span
      >
    </p>
  </b-list-group-item>
</template>

<script>
export default {
  name: "SupplierItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    term: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped></style>
